import * as React from 'react';
import { FilterProps } from '../filters';
import { Op } from '../../../enums/Op';
import { parseDate, parseCondition, debounce } from '../../../utils';
import { Options } from '../Options/options';
import { RelativeRange } from '../DateFilter/dateFilter';

interface Condition {
  [op: string]: { from?: string; to?: string } | boolean | string[] | string;
}

const OPTIONS = [Op.relative];
const TODAY = 'TODAY';
const P12M = 'P12M';

export const ExpiryDateFilter = ({
  filter,
  field,
  opts,
  setFilter
}: FilterProps) => {
  const curFilter = filter; //findOne(filters, { field: filter.field });
  if (!opts) opts = OPTIONS;
  const conditions: Condition[] = [
    { [Op.relative]: { from: TODAY, to: P12M } }
  ];
  const { op, val } = parseCondition(curFilter.conditions, opts[0]);
  let startDate: any = val,
    endDate: any = null;
  if (Array.isArray(val)) {
    startDate = parseDate(val[0]);
    endDate = parseDate(val[1]);
  } else if (!val?.from) {
    startDate = parseDate(val);
  }

  return (
    <div className="filter-box date-filter">
      <div>
        {field.name}&nbsp;
        <Options
          options={opts}
          disabled={true}
          onSelect={() => {
            setFilter({
              ...curFilter,
              conditions
            });
          }}
          selected={Op.relative}
        />
      </div>
      <div>
        {op == Op.relative && (
          <RelativeRange
            selected={val}
            onChange={debounce(v => {
              const conditions: Condition[] = [{ [op]: v }];
              setFilter({
                ...curFilter,
                conditions
              });
            }, 200)}
          />
        )}
      </div>
    </div>
  );
};
